module.exports = __webpack_public_path__ + "img/ring_y_i_0_null.3c6b54af.png";